import CurrentSplitSelector from './CurrentSplitSelector'

export default CurrentSplitSelector
